// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"fd32700f","140":"009c8a93","169":"955c1e23","330":"d376232c","712":"377f13f6","787":"6c3cc21e","851":"7c5de6e9"}[chunkId] + ".chunk.js";
};